import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import { Spin } from "antd";
import EditROWaterPressure from "./EditROWaterPressure";
import { getApiBaseUrl, GET_PRESSURES } from "../../Config/Config";

const ROWaterPressure = () => {
  const [waterPressureData, setROWaterPressureData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchROWaterPressureData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${getApiBaseUrl()}${GET_PRESSURES}?Type=1`
        );
        const data = await response.json();
        setROWaterPressureData(data?.ResultData || []);
      } catch (error) {
        console.error("Error fetching water pressure data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchROWaterPressureData();
  }, []);

  const columns = [
    {
      title: "Min Pressure",
      dataIndex: "Min",
      key: "Min",
      sorter: (a, b) => a.Min - b.Min,
    },
    {
      title: "Max Pressure",
      dataIndex: "max",
      key: "max",
      sorter: (a, b) => a.max - b.max,
    },
    {
      title: "Unit",
      dataIndex: "Unit",
      key: "Unit",
      sorter: (a, b) => a.Unit.localeCompare(b.Unit),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action d-flex align-items-center">
            <Link
              to="#"
              className=" me-2"
              data-bs-toggle="offcanvas"
              data-bs-target="#EditROWaterPressureOffcanvas"
              onClick={() => setSelectedEquip(record)}
              title="Edit"
            >
              <i data-feather="edit" className="feather-edit text-info"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];
  const [selectedEquip, setSelectedEquip] = useState();

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    RO Water Pressure{" "}
                  </h4>
                </ol>
              </nav>
              <h6>Manage RO Water Pressure</h6>
            </div>
          </div>

          {/* <div className="page-btn">
            <Link
              data-bs-toggle="offcanvas"
              data-bs-target="#AddWashingEquipOffcanvas"
              aria-controls="AddWashingEquipOffcanvas"
              className="btn btn-success btn-sm"
            >
              <i className="ti ti-circle-plus fs-4"></i>
            </Link>
          </div> */}
        </div>

        <div>
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
              <div className="search-set mt-4"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : waterPressureData.length > 0 ? (
                  <Table dataSource={waterPressureData} columns={columns} />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <>
        <EditROWaterPressure editObj={selectedEquip} />
      </>
    </div>
  );
};

export default ROWaterPressure;
